import { RRule } from "rrule";

// Define a function to parse RRULE string and extract relevant data.
const dataFromRrule = (rrule) => {
  // Parse the RRULE string and create an RRule object.
  const rruleObject = RRule.fromString(rrule);

  // Extract specific properties from the RRule object.
  const { freq, interval, count, until, byweekday, bymonthday, bynweekday } =
    rruleObject.options;

  // Initialize a variable to store the translated frequency.
  let freqTranslation = "";

  // Translate the numeric frequency value to a human-readable string.
  switch (freq) {
    case 0:
      freqTranslation = "Yearly";
      break;
    case 1:
      freqTranslation = "Monthly";
      break;
    case 2:
      freqTranslation = "Weekly";
      break;
    case 3:
      freqTranslation = "Daily";
      break;
    default:
      break;
  }

  // Return an object containing the extracted data.
  return {
    frequency: freqTranslation,
    interval,
    count,
    until,
    byweekday,
    bymonthday,
    bynweekday,
  };
};

// Export the function for use in other modules.
export default dataFromRrule;
